import { ReactElement, SVGProps } from 'react'
export const SvgVisa = (props: SVGProps<SVGSVGElement>): ReactElement => (
  <svg width={64} height={32} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width={64} height={32} rx={4} fill="#fff" />
    <path
      d="m28.287 9-2.245 13.972h3.589L31.875 9h-3.588Zm10.825 5.691c-1.254-.619-2.023-1.037-2.023-1.67.016-.576.65-1.166 2.068-1.166a6.246 6.246 0 0 1 2.673.517l.326.145.488-2.923a9.058 9.058 0 0 0-3.221-.576c-3.544 0-6.04 1.843-6.055 4.478-.03 1.945 1.786 3.024 3.145 3.671 1.389.664 1.861 1.095 1.861 1.685-.015.906-1.123 1.324-2.156 1.324-1.431 0-2.2-.215-3.367-.72l-.473-.215-.502 3.038c.843.374 2.393.704 4.003.721 3.766 0 6.217-1.815 6.248-4.623.012-1.541-.946-2.721-3.015-3.686Zm12.732-5.648h-2.776c-.856 0-1.506.246-1.877 1.124l-5.33 12.805h3.766l1.037-2.772h4.214l.538 2.783h3.322l-2.894-13.94Zm-4.135 8.359c.072.007 1.445-4.526 1.445-4.526l1.093 4.526H47.71ZM23.043 9l-3.516 9.493-.383-1.872c-.65-2.16-2.688-4.508-4.963-5.673l3.22 12.01h3.797L26.84 9.002h-3.797V9Z"
      fill="#2394BC"
    />
    <path
      d="M17.96 10.801c-.274-1.065-1.147-1.784-2.334-1.799h-5.569L10 9.26c4.344 1.071 7.99 4.367 9.172 7.466L17.96 10.8Z"
      fill="#EFC75E"
    />
  </svg>
)
